import { useState } from "react";

export const ServiceNotes = ({ serviceReqInfo }: { serviceReqInfo: string }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 150; // Adjust as needed

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="p-0 singleTenantNameDetailsLeftSide">
      <div className="singleTenantDetailsName d-flex gap-1">
        <span className="sub_text black fw-500">Description:</span>

      <div className="description-container">
        <p className="sub_text black fw-normal clickable" onClick={toggleReadMore}>
          {isExpanded || serviceReqInfo?.length <= maxLength
            ? serviceReqInfo
            : `${serviceReqInfo?.substring(0, maxLength)}...`}<span className="sub_text fw-600 blue ml-1 clickable" onClick={toggleReadMore}> {isExpanded ? "▲" : "▼"}</span>
        </p>
      </div>
      </div>
    </div>
  );
};
